import React from 'react';
import { observer } from 'mobx-react';
import AddSubuserComponent from './Add-subuser.component';
import useAddSubuser from './useAddSubuser';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { subusers, lang, state, handlers } = useAddSubuser(onClose);

    return (
        <>
            <AddSubuserComponent
                lang={lang.lang}
                login={state.login}
                loginError={state.loginError}
                password={state.password}
                passwordError={state.passwordError}
                passwordConfirm={state.passwordConfirm}
                passwordConfirmError={state.passwordConfirmError}
                serverError={subusers.serverError}
                registerError={subusers.registerError}
                loading={subusers.addSubuserLoading || subusers.loading}
                onLoginChange={handlers.handleLoginChange}
                onPasswordChange={handlers.handlePasswordChange}
                onPasswordConfirmChange={handlers.handlePasswordConfirmChange}
                onCreateClick={handlers.handleCreateClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
            />
        </>
    );
};

const AddSubuserContainer = observer(Container);

export default AddSubuserContainer;
